export function LanguageEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="131"
        viewBox="0 0 200 131"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M122 32H78C63.6406 32 52 43.6406 52 58V102C52 116.359 63.6406 128 78 128H122C136.359 128 148 116.359 148 102V58C148 43.6406 136.359 32 122 32Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M82 74L90 54L98 74"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M85 67H95" stroke="var(--clr-general-primary)" strokeLinecap="round" />
        <path
          d="M108 58C114 57.3334 117 59.6667 117 65C117 69.6667 114.333 71.3334 109 70"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
        />
        <path
          d="M84 94C88 98.6667 92 98.6667 96 94"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 94C108 98.6667 112 98.6667 116 94"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 108C97.3333 112 102.667 112 108 108"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 106.5C80.1569 106.5 81.5 105.157 81.5 103.5C81.5 101.843 80.1569 100.5 78.5 100.5C76.8431 100.5 75.5 101.843 75.5 103.5C75.5 105.157 76.8431 106.5 78.5 106.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 106.5C120.157 106.5 121.5 105.157 121.5 103.5C121.5 101.843 120.157 100.5 118.5 100.5C116.843 100.5 115.5 101.843 115.5 103.5C115.5 105.157 116.843 106.5 118.5 106.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M158 19C150 23 144.667 29 142 37"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M161.999 14.9999C167.856 10.793 173.922 12.5824 175.131 18.5438C169.205 20.752 164.138 18.9277 161.999 14.9999Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M162 15C159.791 9.0735 163.614 3.93695 169.611 3.72755C169.82 9.72389 166.962 13.8262 162 15Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M169 111L171 116L176 118L171 120L169 125L167 120L162 118L167 116L169 111Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M35.6 50.2C37.0359 50.2 38.2 49.0359 38.2 47.6C38.2 46.1641 37.0359 45 35.6 45C34.1641 45 33 46.1641 33 47.6C33 49.0359 34.1641 50.2 35.6 50.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
